import { useState, useEffect } from "react";
// TODO remove @material-ui
import { makeStyles, Typography, IconButton, Table, TableContainer, TableHead, TableBody, TableRow, TableCell } from "@material-ui/core";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import CloseIcon from "@material-ui/icons/Close";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import InvalidIcon from "@material-ui/icons/Warning";
import { getObjectValue } from "../utils/commonUtilityFunctions";
import { isEncodedContent, isStartsWith } from "@cti-workspace/helpers";
import { Box, Dialog, DialogTitle, DialogContent } from "@cti-workspace/ui";
import { dateFomat } from "../utils/dateFormat";
import { Description } from "../VerifierPageComponents/Typography";
const PRIMARY_COLOR_LIGHT = "#f1f2f0";
const SECONDARY_COLOR_LIGHT = "#009198";
const options = { year: "numeric", month: "long", day: "numeric" };

const useStyles = makeStyles((theme) => ({
	whiteLink: {
		color: "white",
		marginRight: theme.spacing(2),
		fontSize: "0.8rem",
		textDecoration: "underline",
		cursor: "pointer",
	},
	activeItem: {
		border: "1px solid #b1aaaa",
		borderRadius: "20px",
		paddingLeft: "10px",
		paddingRight: "10px",
		backgroundColor: "#009198",
		color: "white",
	},
	button: {
		backgroundColor: "#009198",
		color: "white",
		padding: "15px",
		borderRadius: "30px",
		fontWeight: "normal",
		"&:hover": {
			backgroundColor: "#009198",
			borderColor: "#009198",
			boxShadow: "none",
		},
		"&:active": {
			boxShadow: "none",
			backgroundColor: "#009198",
			borderColor: "#009198",
		},
		"&:focus": {
			boxShadow: "0 0 0 0.2rem #009198",
		},
	},
	iconButton: {
		backgroundColor: "#009198",
		display: "flex",
		height: "30px",
		width: "30px",
		borderRadius: "50%",
		alignItems: "center",
		justifyContent: "center",
		position: "absolute",
		top: "10px",
		right: "10px",
	},
	avatar: {
		border: "2px solid #009198",
		display: "flex",
		width: "45px",
		height: "45px",
		borderRadius: "40px",
		color: "#009198",
		alignItems: "center",
		justifyContent: "center",
		fontSize: "1.3rem",
	},
}));

const ModeSwitch = () => {
	return (
		<div style={{ border: "1px solid #515052", display: "flex", alignItems: "center", justifyContent: "space-between", paddingLeft: "10px", paddingRight: "5px", borderRadius: "30px", width: "90px", backgroundColor: "#2d2a2e" }}>
			<Typography variant="subtitle1" style={{ color: "#b1aaaa" }}>
				Light
			</Typography>
			<div style={{ height: "20px", width: "20px", borderRadius: "20px", backgroundColor: "violet" }}></div>
			{/* <div>Dark</div> */}
		</div>
	);
};

const SimpleTable = ({ rows }) => {
	return (
		<div className="verifier-content-table">
			<TableContainer>
				<Table size="small" aria-label="simple table" style={{ width: "auto", tableLayout: "auto" }}>
					<TableBody>
						{rows.length < 21 &&
							rows
								.filter((row) => !isEncodedContent(row.value))
								.map((row) => (
									<TableRow key={row.name} style={{ paddingBlock: 0 }}>
										<TableCell align="left" style={{ paddingBlock: "4px", borderRight: "1px solid #e0e0e0" }}>
											<b>{row.name}: </b>
										</TableCell>
										<TableCell align="left" style={{ paddingBlock: "4px" }}>
											{isStartsWith(row.value, "http") ? (
												<a href={row.value} target="_blank" rel="noopener noreferrer">
													{row.value}
												</a>
											) : (
												row.value
											)}
										</TableCell>
									</TableRow>
								))}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

const ResourceTable = ({ rows }) => {
	return (
		<TableContainer>
			<Table size="small" aria-label="simple table">
				<TableBody>
					{rows.length < 21 &&
						rows.map((row) => (
							<TableRow key={row.id}>
								<TableCell align="left" style={{ borderBottom: "none", padding: 0 }}>
									<li style={{ color: "#009198" }}>
										<a style={{ color: "#009198" }} href={row.url} target="_blank" rel="noopener noreferrer">
											{row.id}
										</a>
									</li>
								</TableCell>
							</TableRow>
						))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

const CertificateBadgeSwitch = () => {
	const styles = useStyles();
	return (
		<div
			style={{
				display: "flex",
				border: "solid 1px #b1aaaa",
				width: "170px",
				justifyContent: "space-between",
				padding: "3px",
				paddingRight: "10px",
				paddingLeft: "5px",
				backgroundColor: PRIMARY_COLOR_LIGHT,
				alignItems: "center",
				borderRadius: "30px",
				margin: "auto",
			}}>
			<div className={styles.activeItem} style={{ fontSize: "1rem" }}>
				Certificate
			</div>
			<div style={{ fontSize: "1rem", color: "#b1aaaa" }}>Badge</div>
		</div>
	);
};

const CertificateOptions = ({ hidden = false, title, tempUrl, handleClick }) => {
	return <div style={{ display: "flex", gap: "10px", marginTop: "2rem" }}>{!hidden && <OptionButton onClick={handleClick} title={title} startIcon={<InsertDriveFileOutlinedIcon fontSize="small" />} tempUrl={tempUrl} />}</div>;
};

const BadgeOptions = ({ hidden = false, title, tempUrl }) => {
	return (
		<div style={{ display: "flex", gap: "10px", marginTop: "2rem" }}>
			{!hidden && (
				<a
					href={tempUrl}
					style={{
						display: "flex",
						paddingLeft: "15px",
						paddingRight: "15px",
						alignItems: "center",
						borderRadius: "50px",
						justifyContent: "center",
						color: "white",
						backgroundColor: SECONDARY_COLOR_LIGHT,
						cursor: "pointer",
						minHeight: "43px",
						textDecoration: "none",
					}}
					download>
					<InsertDriveFileOutlinedIcon fontSize="small" />
					<span style={{ marginLeft: "5px" }}>{title}</span>
				</a>
			)}
		</div>
	);
};

const OptionButtonDropdown = ({ title = "Button", startIcon = null, endIcon = null, onClick = () => { }, options = [] }) => {
	return (
		<div
			style={{
				display: "flex",
				paddingLeft: "15px",
				paddingRight: "15px",
				alignItems: "center",
				borderRadius: "50px",
				justifyContent: "space-between",
				color: "black",
				backgroundColor: PRIMARY_COLOR_LIGHT,
				border: `2px solid ${SECONDARY_COLOR_LIGHT}`,
				cursor: "pointer",
				minHeight: "43px",
				minWidth: "150px",
			}}
			onClick={onClick}>
			<div style={{ display: "flex", alignItems: "center" }}>
				{startIcon}
				<span style={{ marginLeft: "5px" }}>{title}</span>
			</div>
		</div>
	);
};

const OptionButton = ({
	title = "Button",
	startIcon = null,
	onClick = () => {
		return null;
	},
}) => {
	return (
		<div
			style={{
				display: "flex",
				paddingLeft: "15px",
				paddingRight: "15px",
				alignItems: "center",
				borderRadius: "50px",
				justifyContent: "center",
				color: "white",
				backgroundColor: SECONDARY_COLOR_LIGHT,
				cursor: "pointer",
				minHeight: "43px",
			}}
			onClick={onClick}>
			{startIcon}
			<span style={{ marginLeft: "5px" }}>{title}</span>
		</div>
	);
};

const VButton = ({ title = "Button", startIcon = null, onClick = () => { } }) => {
	return (
		<div
			style={{
				display: "flex",
				paddingLeft: "15px",
				paddingRight: "15px",
				alignItems: "center",
				borderRadius: "50px",
				justifyContent: "center",
				color: "white",
				backgroundColor: SECONDARY_COLOR_LIGHT,
				cursor: "pointer",
				minHeight: "43px",
			}}
			onClick={onClick}>
			{startIcon}
			<span style={{ marginLeft: "5px", fontFamily: "Plus Jakarta Sans", letterSpacing: 1, fontWeight: 700, textTransform: "capitalize" }}>{title}</span>
		</div>
	);
};

const BadgeIssuedTextRow = ({ doc, locale }) => {
	const styles = {
		voiletColor: {
			color: "#009198",
		},
	};
	return (
		<Typography variant="subtitle1">
			This credential was issued to <span style={{ ...styles.voiletColor, textDecoration: "underline" }}>{doc?.credentialSubject?.name}</span> on{" "}
			{doc?.issuanceDate ? dateFomat({ date: doc?.issuanceDate, locale }) : dateFomat({ date: doc?.issuedOn, locale })} {doc?.expiredOn && <span style={styles.voiletColor}>Expires on {dateFomat({ date: doc?.expiredOn, locale })}</span>}
		</Typography>
	);
};

const SectionClaimsTable = ({ rows, theme }) => {
	return (
		<div>
			<table size="small" aria-label="simple table">
				<tbody>
					{rows.length < 21 &&
						rows
							.filter((row) => row.value)
							.map((row) => (
								<tr key={row.name} style={{ fontSize: "1rem" }}>
									<td style={{ borderBottom: "none", paddingBlock: 0, textAlign: "left", paddingInline: "16px" }}>
										<b>
											<Description theme={theme}>{row.name}: </Description>
										</b>
										<Description theme={theme}>{row.value}</Description>
									</td>
								</tr>
							))}
				</tbody>
			</table>
		</div>
	);
};

const BulkVerificationResult = ({ data = [], onClose = () => { }, objLinks = {} }) => {
	const [unVerified, setUnVerified] = useState([]);
	const [verified, setVerified] = useState([]);
	useEffect(() => {
		if (data.length) {
			// add original link to the credential to verify it
			const { unVerifiedData, verifiedData } = data.reduce(
				(acc, item) => {
					// objLinks;
					if (item.message[0].verified) {
						const verifiedData = acc.verifiedData;
						const { [getObjectValue(item, "credential.id")]: objLinksObj } = objLinks;
						verifiedData.push({ credential: item.credential, ...item.message[0], id: objLinksObj.id, email: objLinksObj.email });
						return {
							...acc,
							verifiedData,
						};
					} else {
						const unVerifiedData = acc.unVerifiedData;
						const { [getObjectValue(item, "credential.id")]: objLinksObj } = objLinks;
						unVerifiedData.push({ ...item, id: objLinksObj.id, email: objLinksObj.email });
						return {
							...acc,
							unVerifiedData,
						};
					}
				},
				{ unVerifiedData: [], verifiedData: [] }
			);
			setVerified(verifiedData);
			setUnVerified(unVerifiedData);
		}
	}, [data]);

	return (
		<Dialog open maxWidth="md" fullWidth onClose={onClose}>
			<DialogTitle>
				<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
					<Typography variant="h6">Verification Results</Typography>
					<IconButton color="secondary" onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</div>
			</DialogTitle>
			<DialogContent>
				{unVerified.length > 0 ? (
					<Box elevation={1} padding={2} marginBottom={2}>
						<Typography variant="subtitle1">Invalid (Please review)</Typography>
						<ListTableContents
							headers={[
								{ label: "Verified", prop: "", width: "50px", align: "center" },
								{ label: "Reason", prop: "message", altProp: "message" },
								{ label: "Email", prop: "email" },
								{ label: "Name", prop: "credential.recipientName" },
							]}
							data={unVerified}
						/>
					</Box>
				) : null}
				{verified.length > 0 ? (
					<Box elevation={1} padding={2}>
						<ListTableContents
							headers={[
								{ label: "Verified", prop: "", width: "50px", align: "center" },
								{ label: "Name", prop: "credential.recipientName" },
								{ label: "Email", prop: "email" },
								{ label: "View", prop: "id" },
							]}
							data={verified}
						/>
					</Box>
				) : null}
			</DialogContent>
		</Dialog>
	);
};

const ListTableContents = ({ headers = [], data = [] }) => {
	const renderItem = (row, item) => {
		const strData = getObjectValue(row, item.prop);
		if (typeof strData !== "string") {
			if (item.altProp) {
				return getObjectValue(row, item.altProp, "");
			}
		}
		return getObjectValue(row, item.prop);
	};
	console.log(data);
	return (
		<Table size="small">
			<TableHead>
				<TableRow key={"header"}>
					{headers.map((item) => (
						<TableCell width={item?.width} align={item?.align} style={{ fontWeight: "bold" }}>
							{item.label}
						</TableCell>
					))}
				</TableRow>
			</TableHead>
			<TableBody>
				{data.map((row, index) => (
					<TableRow key={index}>
						{headers.map((item, i) =>
							item.prop === "" ? (
								<TableCell key={`${index}+${item.prop}`} align={item?.align}>
									{row.verified ? <VerifiedUserIcon htmlColor="green" /> : <InvalidIcon color="error" />}
								</TableCell>
							) : item.prop === "id" ? (
								<TableCell key={`${index}+${item.prop}`}>
									<a href={`/verifier?id=${getObjectValue(row, item.prop)}`}>{getObjectValue(row, item.prop)}</a>
								</TableCell>
							) : (
								<TableCell key={`${index}+${item.prop}`}>{renderItem(row, item)}</TableCell>
							)
						)}
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};

export {
	CertificateOptions,
	OptionButtonDropdown,
	OptionButton,
	CertificateBadgeSwitch,
	ModeSwitch,
	useStyles,
	SECONDARY_COLOR_LIGHT,
	PRIMARY_COLOR_LIGHT,
	BadgeIssuedTextRow,
	SectionClaimsTable, // using
	SimpleTable,
	ResourceTable,
	ListTableContents,
	BulkVerificationResult, // using
	VButton, // using
	BadgeOptions,
};
